// extracted by mini-css-extract-plugin
export default {"loaderwrp":"Loader_loaderwrp__wSMNk"};